import styled from 'styled-components';
import BaseMenu from '@/components/Menu';
import SearchInputComponent from '@/components/SearchInput';
import UserInitials from '@/trio-ui/UserInitials';

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 32px;
  margin-bottom: 16px;
`;

export const HeaderTitle = styled.p`
  color: ${({ theme }) => theme.colors['neutral-100']};
  font-size: 18px;
  font-weight: 600;
  line-height: 120%;
  flex-grow: 1;
`;

export const TableContainer = styled.div`
  & > div {
    border: 1px solid ${({ theme }) => theme.colors['neutral-40']};
  }

  & table {
    width: 100%;
    border: 0 none;

    & th:first-child,
    & td:first-child {
      border-left: 0 none;
    }

    & th:last-child,
    & td:last-child {
      border-right: 0 none;
    }

    & th {
      border-top: 0 none;
    }

    & tr:last-child td {
      border-bottom: 0 none;
    }
  }
`;

export const StyledUserInitials = styled(UserInitials)`
  font-size: 14px;
  margin-right: 12px;
`;

export const UserNameAndRole = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  gap: 4px;
`;

export const UserName = styled.span`
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  color: ${({ theme }) => theme.colors['primary-60']};
  display: block;
`;

export const UserNameContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const UserRole = styled.span`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  color: ${({ theme }) => theme.colors['neutral-100']};
  display: block;
`;

export const Tag = styled.span`
  padding: 1px 5px;
  border: 1px solid ${({ theme }) => theme.colors['neutral-70']};
  font-size: 10px;
  font-weight: 400;
  line-height: 140%;
  color: ${({ theme }) => theme.colors['neutral-70']};
  display: block;
  border-radius: 4px;
`;

export const TwoLineRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
`;

export const TableSpan = styled.span`
  display: block;
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
  color: ${({ theme }) => theme.colors['neutral-100']};
`;

export const SpanWithIcon = styled.div`
  display: flex;
  gap: 6.5px;
  align-items: center;

  & > svg {
    fill: ${({ theme }) => theme.colors['neutral-100']};
    width: 15px;
    height: 15px;
  }
`;

export const Menu = styled(BaseMenu)`
  & > button {
    text-transform: uppercase;
    cursor: pointer;
    border-radius: 5px;
    font-weight: 600;
    font-size: 12px;
    transition: background-color 0.3s ease 0s;
    color: ${({ theme }) => theme.colors['primary-60']};
    background-color: ${({ theme }) => theme.colors['neutral-0']};
    border: 1px solid ${({ theme }) => theme.colors['primary-60']};
    padding: 0px 16px;
    width: unset;
    padding-left: 16px;
    padding-right: 16px;
    display: flex;
    align-items: center;
    height: 42px;

    &:hover {
      background-color: ${({ theme }) => theme.colors['secondary-20']};
    }

    &:active {
      background-color: ${({ theme }) => theme.colors['secondary-30']};
    }

    & > svg {
      margin-left: 4px;
      width: 16px;
      height: 16px;
    }
  }

  & > div {
    top: 45px;
  }
`;

export const Search = styled(SearchInputComponent)`
  min-width: 260px;
`;

export const AddNew = styled.button`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  font-size: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => props.theme.colors['tertiary-60']};

  svg {
    fill: #fff;
  }
`;
